import React, { Component } from "react";
import {
	Form,
	Input,
	Select,
	Button,
	DatePicker,
	Checkbox,
	Spin,
	Table,
	Tabs,
	Tooltip,
	message,
	Divider,
} from "antd";
import moment from "moment";
import {
	getHospitalListGroups,
	getBillingDoctorList,
	getOperationDoctorList,
	printPic,
	getSearchDoctorList,
	getGroupHospitalDept,
	getGroupExamItemList,
	getGroupsDataNoPaging,
} from "@/request/api";
import {
	GetFirstGroupData,
	getCustomData,
	getSearchPartSecondData,
	getExportCustomData,
	getConsultationApplyHospitalGroup,
} from '@/request/operatorPartApi';
import "./customSearch.scss";
import { getCommonColumnInfoFn, uniqueJsonArrByField, requestErrorLog } from "../../../common/util";
import EditTable from "../../../components/editTable/index";
const FormItem = Form.Item;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const { TabPane } = Tabs;
export class CustomSearch extends Component {
	state = {
		reportStatus: [],
		departmentList: [],
		consultHospitalList: [],
		applyHospitalList: [],
		doctorList: [],
		reqDeptList: [],
		dataList: [],
		examItemList: [],
		RowCount: 0,
		source: [],
		defaultSelectDate: {
			startDate: moment().subtract(1, "months"),
			endDate: moment().endOf("day"),
		},
		examStatusList: [
			// { label: "未检查", value: 0 }, //自定义查询不需要未检查状态
			{ label: "未报告", value: 1 },
			{ label: "已报告", value: 2 },
			{ label: "已审核", value: 3 },
		],
		consultationStatusList: [
			{ label: "未会诊", value: 1 },
			{ label: "已会诊", value: 2 },
			{ label: "会诊中", value: 3 },
		],
		billingDoctorList: [],
		PageNo: 1,
		PageSize: 10,
		showKey: "ECG",
		tabsloading: false,
		applyDateTimeChecked: false,
		consultationDateTimeChecked: false,
		Column: [
			{
				title: "序号",
				dataIndex: "index",
				key: "index",
				width: 60,
				isShow: true,
				align: "center",
				render: (text, record, index) => {
					//生成序号
					return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
				},
			},
			{
				title: "报告状态",
				dataIndex: "EXAM_STATUS_NAME",
				key: "EXAM_STATUS_NAME",
				align: "center",
				width: 80,
				isShow: true,
				render: (exam) => (
					<span
						style={{
							color:
								exam === "已审核"
									? "#17CC60"
									: exam === "已报告"
										? "#1A92FF"
										: exam === "未报告"
											? "#FF4045"
											: "#000000a6",
						}}>
						{exam}
					</span>
				),
			},
			{
				title: "会诊状态",
				dataIndex: "CONSULTATION_STATUS_NAME",
				key: "CONSULTATION_STATUS_NAME",
				align: "center",
				width: 80,
				isShow: true,
				render: (exam) => (
					<span
						style={{
							color:
								exam === "已会诊"
									? "#17CC60"
									: exam === "会诊中"
										? "#1A92FF"
										: exam === "未会诊"
											? "#FF4045"
											: "#000000a6",
						}}>
						{exam}
					</span>
				),
			},
			{
				title: "姓名",
				dataIndex: "NAME",
				key: "NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip className="sizeWeight" placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "性别",
				dataIndex: "SEX_NAME",
				key: "SEX_NAME",
				align: "center",
				width: 70,
				isShow: true,
			},
			{
				title: "年龄",
				dataIndex: "EXAM_AGE",
				key: "EXAM_AGE",
				align: "center",
				width: 60,
				isShow: true,
				render: (text, record) => {
					return record.EXAM_AGE + record.AGE_UNIT;
				},
			},
			{
				title: "出生日期",
				dataIndex: "BIRTHDAY",
				key: "BIRTHDAY",
				align: "center",
				width: 110,
				isShow: true,
				render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
			},
			{
				title: "手机号",
				dataIndex: "CONTACT_TEL",
				key: "CONTACT_TEL",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "申请会诊日期",
				dataIndex: "APPLY_DATETIME",
				key: "APPLY_DATETIME",
				align: "center",
				width: 160,
				isShow: true,
				render: (val) => (
					<span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				),
			},
			{
				title: "申请医院",
				dataIndex: "APPLY_HOSPITAL_NAME",
				key: "APPLY_HOSPITAL_NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "申请科室",
				dataIndex: "REQ_DEPT_NAME",
				key: "REQ_DEPT_NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "检查项目",
				dataIndex: "ITEM_NAME",
				key: "ITEM_NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},

			{
				title: "开单医生",
				dataIndex: "BILLING_DOCTOR",
				key: "BILLING_DOCTOR",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "最终会诊医院",
				dataIndex: "CONSULTATION_HOSPITAL_NAME",
				key: "CONSULTATION_HOSPITAL_NAME",
				align: "center",
				width: 140,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "会诊人",
				dataIndex: "CONSULTATION_DOCTOR_NAME",
				key: "CONSULTATION_DOCTOR_NAME",
				align: "center",
				width: 110,
				isShow: true,
			},
			{
				title: "完成会诊时间",
				dataIndex: "CONSULTATION_DATE",
				key: "CONSULTATION_DATE",
				align: "center",
				width: 160,
				isShow: true,
				// sorter: (a, b) => new Date(a.CONSULTATION_DATE).getTime() - new Date(b.CONSULTATION_DATE).getTime(),
				render: (val) => (
					<span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				),
			},
			{
				title: "省份",
				dataIndex: "FIRST_GROUP_CODE",
				key: "FIRST_GROUP_CODE",
				align: "center",
				width: 160,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					let firstCodeArr = val?.split(',')
					let firstNameArr = firstCodeArr?.map(item => { return this.state.allGroupData.find(itemA => item === itemA.FIRST_GROUP_CODE).FIRST_GROUP_NAME }).toString()
					return <Tooltip placement="topLeft" title={firstNameArr}>
						{firstNameArr}
					</Tooltip>
				}
			}, {
				title: "代理商",
				dataIndex: "SECOND_GROUP_CODE",
				key: "SECOND_GROUP_CODE",
				align: "center",
				width: 160,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					let secondCodeArr = val?.split(',')
					let secondNameArr = secondCodeArr?.map(item => { return this.state.allGroupData.find(itemA => item === itemA.SECOND_GROUP_CODE).SECOND_GROUP_NAME }).toString()
					return <Tooltip placement="topLeft" title={secondNameArr}>
						{secondNameArr}
					</Tooltip>
				},
			}, {
				title: "签约日期",
				dataIndex: "HOSPITAL_SIGNING_DATE",
				key: "HOSPITAL_SIGNING_DATE",
				align: "center",
				width: 160,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					return <span>{val && moment(val).format("YYYY-MM-DD")}</span>
				},
			}, {
				title: "业务人员",
				dataIndex: "OPERATION_NAME",
				key: "OPERATION_NAME",
				align: "center",
				width: 100,
				isShow: true,
				ellipsis: true,
			},
		],
		localColumn: [
			{
				title: "序号",
				dataIndex: "index",
				key: "index",
				width: 60,
				isShow: true,
				align: "center",
				render: (text, record, index) => {
					//生成序号
					return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
				},
			},
			{
				title: "报告状态",
				dataIndex: "EXAM_STATUS_NAME",
				key: "EXAM_STATUS_NAME",
				align: "center",
				width: 80,
				isShow: true,
				render: (exam) => (
					<span
						style={{
							color:
								exam === "已审核"
									? "#17CC60"
									: exam === "已报告"
										? "#1A92FF"
										: exam === "未报告"
											? "#FF4045"
											: "#000000a6",
						}}>
						{exam}
					</span>
				),
			},
			{
				title: "姓名",
				dataIndex: "NAME",
				key: "NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip className="sizeWeight" placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "性别",
				dataIndex: "SEX_NAME",
				key: "SEX_NAME",
				align: "center",
				width: 70,
				isShow: true,
			},
			{
				title: "年龄",
				dataIndex: "EXAM_AGE",
				key: "EXAM_AGE",
				align: "center",
				width: 60,
				isShow: true,
				render: (text, record) => {
					return record.EXAM_AGE + record.AGE_UNIT;
				},
			},
			{
				title: "出生日期",
				dataIndex: "BIRTHDAY",
				key: "BIRTHDAY",
				align: "center",
				width: 110,
				isShow: true,
				render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
			},
			{
				title: "手机号",
				dataIndex: "CONTACT_TEL",
				key: "CONTACT_TEL",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "门诊号",
				dataIndex: "OUTP_NO",
				key: "OUTP_NO",
				align: "center",
				width: 100,
				isShow: true,
			},
			{
				title: "住院号",
				dataIndex: "INP_NO",
				key: "INP_NO",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "病区",
				dataIndex: "ROOM_NO",
				key: "ROOM_NO",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "创建日期",
				dataIndex: "CREATE_DATE",
				key: "CREATE_DATE",
				align: "center",
				width: 110,
				isShow: true,
				render: (val) => <span>{val && moment(val).format("YYYY-MM-DD")}</span>,
			},
			{
				title: "床号",
				dataIndex: "BED_NO",
				key: "BED_NO",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "开单医生",
				dataIndex: "BILLING_DOCTOR",
				key: "BILLING_DOCTOR",
				align: "center",
				width: 100,
				isShow: true,
			},
			{
				title: "患者来源",
				dataIndex: "PATIENT_SOURCE_NAME",
				key: "PATIENT_SOURCE_NAME",
				align: "center",
				width: 110,
				isShow: true,
			},
			{
				title: "检查时间",
				dataIndex: "EXAM_DATETIME",
				key: "EXAM_DATETIME",
				align: "center",
				width: 160,
				isShow: true,
				sorter: (a, b) =>
					new Date(a.REQ_DATETIME).getTime() -
					new Date(b.REQ_DATETIME).getTime(),
				render: (val) => (
					<span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				),
			},
			{
				title: "检查项目",
				dataIndex: "ITEM_NAME",
				key: "ITEM_NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "报告人",
				dataIndex: "REPORT_DOCTOR_NAME",
				key: "REPORT_DOCTOR_NAME",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "报告时间",
				dataIndex: "REPORT_DATETIME",
				key: "REPORT_DATETIME",
				align: "center",
				width: 160,
				isShow: true,
				sorter: (a, b) =>
					new Date(a.REQ_DATETIME).getTime() -
					new Date(b.REQ_DATETIME).getTime(),
				render: (val) => (
					<span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				),
			},
			{
				title: "审核人",
				dataIndex: "CHECK_DOCTOR_NAME",
				key: "CHECK_DOCTOR_NAME",
				align: "center",
				width: 120,
				isShow: true,
			},
			{
				title: "审核时间",
				dataIndex: "CHECK_DATETIME",
				key: "CHECK_DATETIME",
				align: "center",
				width: 160,
				isShow: true,
				sorter: (a, b) =>
					new Date(a.REQ_DATETIME).getTime() -
					new Date(b.REQ_DATETIME).getTime(),
				render: (val) => (
					<span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
				),
			},
			{
				title: "检查结论",
				dataIndex: "CONCLUSIONS",
				key: "CONCLUSIONS",
				align: "center",
				width: 140,
				isShow: true,
				ellipsis: true,
				render: (text) => {
					return (
						<Tooltip placement="topLeft" title={text}>
							{text}
						</Tooltip>
					);
				},
			},
			{
				title: "医院名称",
				dataIndex: "HOSPITAL_NAME",
				key: "HOSPITAL_NAME",
				align: "center",
				width: 140,
				isShow: true,
				ellipsis: true,
			},
			{
				title: "省份",
				dataIndex: "FIRST_GROUP_NAME",
				key: "FIRST_GROUP_NAME",
				align: "center",
				width: 120,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					return <Tooltip placement="topLeft" title={val}>
						{val}
					</Tooltip>
				},
			}, {
				title: "代理商",
				dataIndex: "SECOND_GROUP_NAME",
				key: "SECOND_GROUP_NAME",
				align: "center",
				width: 160,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					return <Tooltip placement="topLeft" title={val}>
						{val}
					</Tooltip>
				},
			}, {
				title: "签约日期",
				dataIndex: "HOSPITAL_SIGNING_DATE",
				key: "HOSPITAL_SIGNING_DATE",
				align: "center",
				width: 160,
				isShow: true,
				ellipsis: true,
				render: (val) => {
					return <span>{val && moment(val).format("YYYY-MM-DD")}</span>
				},
			},
		],
		billDoctorList: [], //开单医生列表
		consultationOrLocalSearch: 0, //0会诊查询；1本地查询
		showColumn: false,
		localReportDoctorList: [],
		localprocessDoctorList: [],
		localBillingDoctorList: [],
		applyHosptalList: JSON.parse(localStorage.getItem('operaterInfo')).hospitalData,
		DateCheckChecked: false,
		REPORTSChecked: false,
		CHECKSChecked: false,
		localDataList: [],
		firstGroupList: [],//一级分组列表
		secondGroupList: [],//一级分组列表
		firstGroupName: '',
		secondGroupName: '',
		examGroupItemList: [],
		repeatSecondGroupList: [],//未去重的二级分组
		operaterInfo: JSON.parse(localStorage.getItem('operaterInfo')),
		salesmanData: JSON.parse(localStorage.getItem('operaterInfo')).salesmanData,
		allGroupData: [],

		selectFirstAllState: false,
		indeterminateFirst: false,
		selectSecondAllState: false,
		indeterminateSecond: false,
	};
	// 只能选择今天跟今天之前的日期
	disabledDate(current) {
		return current > moment().subtract(-1, "day");
	}
	async componentDidMount() {
		//获取当前登录人所在分组
		const { operaterInfo } = this.state
		let hospitalData = operaterInfo.hospitalData.map(item => item.HOSPITAL_CODE).toString()
		let res = await GetFirstGroupData(hospitalData);
		let firstGroupList = []
		if (res && res.Status === 1) {
			firstGroupList = res.Result
		} else {
			requestErrorLog('', '运营综合查询-自定义查询-获取一级分组报错', 0, true)
		};
		//二次需求：一级分组为空也请求二级分组列表
		let firstArr = firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
		let secondGroupList = await this.getSearchPartSecondData(firstArr)
		//需要一个去过重的二级列表和一个没去过重的二级列表
		let repeatSecondGroupList = [...secondGroupList]
		secondGroupList = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
		let stateObject = {
			firstGroupList,
			secondGroupList,
			repeatSecondGroupList,
		}
		let examParam = {
			Type: "GetExam_ItemList",
			EXAM_CLASS: this.state.showKey
		}
		let examRes = await getGroupExamItemList(examParam)
		if (examRes && examRes.Status === 1) {
			stateObject.examGroupItemList = examRes.Result ? examRes.Result : [];
		};
		//获取所有分组数据
		let allGroupDataRes = await getGroupsDataNoPaging()
		if (allGroupDataRes && allGroupDataRes.Status === 1) {
			stateObject.allGroupData = allGroupDataRes.Result ? allGroupDataRes.Result : [];
		} else {
			requestErrorLog('', '运营综合查询-自定义查询-获取所有分组报错', 0, true)
		};
		this.setState(stateObject);
		this.searchListFn();//搜索数据
		this.initCommonColumn();//本地数据初始化表头
	}
	// 请求会诊医院列表
	initHospitalList(FIRST_GROUP_CODE, SECOND_GROUP_CODE) {
		FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
		SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
		let Param = {
			Type: "HospitalListGroup",
			FIRST_GROUP_CODE,//一级分组
			SECOND_GROUP_CODE,//二级分组
		};
		getHospitalListGroups(Param).then((res) => {
			if (res && res.Status === 1) {
				this.setState({
					consultHospitalList: res.Result ? res.Result : [],
				});
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-获取会诊医院报错', 0, true)
			}
		});
	}
	//请求二级分组列表
	async getSearchPartSecondData(firstGroupData) {
		let res = await getSearchPartSecondData("E00144", '', firstGroupData.toString())
		if (res && res.Status === 1) {
			return res.Result ? res.Result : []
		} else {
			requestErrorLog('', '运营综合查询-自定义查询-获取二级分组报错', 0, true)
			return []
		}
	}
	//选择一级分组，所有下拉列表框按照联动逻辑走，前一个选了，后边才有数据
	firstGroupChange = async (firstGroupData) => {
		//多级联动一级分组改变
		let changeStateData = this.someLevelLinkage('secondGroupList');
		if (firstGroupData.length > 0) {//分组一改变，分组二列表赋值
			let firstGroupName = this.state.firstGroupList.filter(item => firstGroupData.indexOf(item.FIRST_GROUP_CODE) > -1).map((item) => { return item.FIRST_GROUP_NAME })
			changeStateData.secondGroupList = await this.getSearchPartSecondData(firstGroupData);
			changeStateData.firstGroupName = firstGroupName
			changeStateData.secondGroupName = ''
		} else {
			changeStateData.firstGroupName = ''
			changeStateData.secondGroupName = ''
			//二次需求：一级分组为空也请求二级分组列表
			let firstArr = this.state.firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
			let secondGroupList = await this.getSearchPartSecondData(firstArr)
			//需要一个去过重的二级列表
			secondGroupList = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
			changeStateData.secondGroupList = secondGroupList

		}
		//分组1勾选时，给分组二的全选框赋空
		changeStateData.indeterminateSecond = false;
		changeStateData.selectSecondAllState = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (firstGroupData.length > 0 && firstGroupData.length < this.state.firstGroupList.length) {
			changeStateData.indeterminateFirst = true
		} else {
			changeStateData.indeterminateFirst = false
			if (firstGroupData.length === this.state.firstGroupList.length) {
				changeStateData.selectFirstAllState = true
			} else {
				changeStateData.selectFirstAllState = false
			}
		}
		this.setState(changeStateData);
	};
	//选择二级分组
	secondGroupChange = async (secondGroupData) => {//二次需求：一级分组为空也请求二级分组列表；单纯二级分组发生变化，不处理原来搜索框联动逻辑
		if (this.props.form.getFieldValue("FIRST_GROUP_CODE")) {
			//多级联动二级分组改变
			let changeStateData = this.someLevelLinkage('consultHospitalList');
			changeStateData.secondGroupName = ''
			if (secondGroupData.length > 0) {
				let secondGroupName = this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME })
				changeStateData.secondGroupName = secondGroupName
				let firstGroupData = this.props.form.getFieldValue("FIRST_GROUP_CODE").toString();
				this.initHospitalList(firstGroupData, secondGroupData);
			}
			this.setState(changeStateData);
		} else {
			let secondGroupName = ''
			if (secondGroupData.length > 0) {
				secondGroupName = this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME })
			}
			this.setState({
				secondGroupName,
			})
		}
		//分组1勾选时，给分组二的全选框赋空
		let indeterminateSecond = false;
		let selectSecondAllState = false;
		//选中的数据不等于全选的数据长度，全选框为半选状态
		if (secondGroupData.length > 0 && secondGroupData.length < this.state.secondGroupList.length) {
			indeterminateSecond = true
		} else {
			if (secondGroupData.length === this.state.secondGroupList.length) {
				selectSecondAllState = true
			}
		}
		this.setState({
			indeterminateSecond,
			selectSecondAllState
		})
	}
	//选择会诊医院
	consultHospitalChange = async (code, secondGroupData) => {
		let changeStateData = this.someLevelLinkage('doctorList,applyHospitalList');
		if (code) {//选中某一个会诊医院，获取会诊人列表和申请医院列表
			let FIRST_GROUP_CODE = this.props.form.getFieldValue("FIRST_GROUP_CODE").toString();
			let SECOND_GROUP_CODE = Array.isArray(secondGroupData) ? secondGroupData.toString() : this.props.form.getFieldValue("SECOND_GROUP_CODE").toString();
			let Param = {
				Type: "GetApplyHospitalData",
				HOSPITAL_CODE: code,
				FIRST_GROUP_CODE,
				SECOND_GROUP_CODE,
				OPERATION_UID: this.state.operaterInfo.OPERATION_UID
			};
			let applyHospitalListRes = await getConsultationApplyHospitalGroup(Param);
			if (applyHospitalListRes && applyHospitalListRes.Status === 1) {
				changeStateData.applyHospitalList = applyHospitalListRes.Result ? applyHospitalListRes.Result : [];
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-获取申请医院报错', 0, true)
			}
			let doctorParam = {
				Type: "GetDoctorList",
				hospital_Code: code,
				FIRST_GROUP_CODE,
				SECOND_GROUP_CODE,
			}
			let doctorListRes = await getSearchDoctorList(doctorParam);
			if (doctorListRes && doctorListRes.Status === 1) {
				changeStateData.doctorList = doctorListRes.Result ? doctorListRes.Result : [];
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-获取会诊人报错', 0, true)
			}
		}
		if (Array.isArray(secondGroupData)) {
			let applyHospitalList = changeStateData.applyHospitalList
			let doctorList = changeStateData.doctorList
			return {
				applyHospitalList, doctorList
			}
		}
		this.setState(changeStateData);
	};
	//申请医院改变
	applyHospitalChange = async (code) => {
		let changeStateData = this.someLevelLinkage('billDoctorList,reqDeptList');
		if (code) {
			let FIRST_GROUP_CODE = this.props.form.getFieldValue("FIRST_GROUP_CODE").toString();
			let SECOND_GROUP_CODE = this.props.form.getFieldValue("SECOND_GROUP_CODE").toString();
			let HOSPITAL_CODE = this.props.form.getFieldValue("CONSULTATION_HOSPITAL_CODE").toString();
			//获取申请科室
			let Param = {
				Type: "GetHospital_Dept",
				HOSPITAL_CODE,//会诊医院
				APPLY_HOSPITAL_CODE: code,//申请医院
				FIRST_GROUP_CODE,//一级分组
				SECOND_GROUP_CODE,//二级分组
			}
			let res = await getGroupHospitalDept(Param)
			if (res && res.Status === 1) {
				changeStateData.reqDeptList = res.Result ? res.Result : [];
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-获取科室列表报错', 0, true)
			};
			//选择申请医院，获取开单医生和申请科室列表
			changeStateData.billDoctorList = await this.initBillDoctorList(code);
		}
		this.setState(changeStateData);
	};

	//开单医生列表
	initBillDoctorList = async (code) => {
		let billDoctorList = []
		let consulationCode = this.props.form.getFieldValue("CONSULTATION_HOSPITAL_CODE");
		let params = {
			Type: "GetBillingDoctorData",
			QUERY_YEAR: moment(this.state.billValue).format("YYYY"),
			HOSPITAL_CODE: consulationCode,
			APPLY_HOSPITAL_CODE: code,
		};
		let res = await getBillingDoctorList(params)
		if (res && res.Status === 1) {
			billDoctorList = res.Result ? res.Result : []
		} else {
			requestErrorLog('', '运营综合查询-自定义查询-获取开单医生列表报错', 0, true)
		}
		return billDoctorList;
	};

	//清空form
	handleChangeResetLocal = () => {
		this.props.form.resetFields();
		this.setState({
			REPORTSChecked: false,
			CHECKSChecked: false,

			REPORT_DOCTOR_NAME: "",
			REPORT_DOCTOR_UID: "",

			CHECK_DOCTOR_NAME: "",
			CHECK_DOCTOR_CODE: "",
		});
		this.localApplyHospitalChange('');
	};
	//清空form
	handleChangeReset = () => {
		this.props.form.resetFields();
		let changeStateData = this.someLevelLinkage('secondGroupList');
		this.setState({
			applyDateTimeChecked: false,
			consultationDateTimeChecked: false,
			DateCheckChecked: false,
			...changeStateData,
			firstGroupName: '',
			secondGroupName: '',
		})
	}

	//搜索数据
	searchListFn = () => {
		this.setState(
			{
				PageNo: 1,
				PageSize: 10,
			},
			() => {
				this.getDataList();
			}
		);
	};
	//列表数据
	getDataList = async () => {
		let params;
		if (this.state.consultationOrLocalSearch === 0) {
			params = await this.beforeInterface();
		} else {
			params = await this.localBeforeInterface();
		}
		getCustomData(params).then((res) => {
			this.setState({ tabsloading: false });
			if (res && res.Status === 1) {
				this.setState({
					dataList: res.Result.list,
					RowCount: res.Result.RowCount,
				});
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-获取自定义列表数据报错', 0, true)
			}
		});
	};
	//换页
	onChangePage = (PageNo) => {
		this.setState(
			{
				PageNo,
			},
			() => {
				this.getDataList();
			}
		);
	};
	//会诊时间改变
	consultationDateTimeChange = (e) => {
		this.setState({
			consultationDateTimeChecked: e.target.checked,
		});
	};
	//申请时间改变
	applyDateTimeChange = (e) => {
		this.setState({
			applyDateTimeChecked: e.target.checked,
		});
	};
	//切换tab
	handleTabKey = async (showKey) => {
		this.props.form.setFieldsValue({
			ITEM_CODE: '',
		});
		let examGroupItemList = []
		let examParam = {
			Type: "GetExam_ItemList",
			EXAM_CLASS: showKey
		}
		let examRes = await getGroupExamItemList(examParam)
		if (examRes && examRes.Status === 1) {
			examGroupItemList = examRes.Result ? examRes.Result : [];
		} else {
			requestErrorLog('', '运营综合查询-自定义查询-切换心电数据类型报错', 0, true)
		};
		this.setState(
			{
				showKey,
				examGroupItemList,
			},
			() => {
				this.searchListFn();
			}
		);
	};
	//会诊查询form数据
	beforeInterface = () => {
		this.setState({ tabsloading: true });
		return new Promise((resolve, reject) => {
			this.props.form.validateFields((err, values) => {
				if (!err) {
					if (
						this.state.applyDateTimeChecked &&
						values.applyStartTime > values.applyEndTime
					) {
						message.error("创建日期开始时间不得大于结束时间");
						this.setState({ tabsloading: false });
						return;
					}
					if (
						this.state.consultationDateTimeChecked &&
						values.consultationStartTime > values.consultationEndTime
					) {
						message.error("会诊完成日期开始时间不得大于结束时间");
						this.setState({ tabsloading: false });
						return;
					}

					let FIRST_GROUP_CODE = values.FIRST_GROUP_CODE ? values.FIRST_GROUP_CODE.toString() : ''
					let SECOND_GROUP_CODE = values.SECOND_GROUP_CODE ? values.SECOND_GROUP_CODE.toString() : ''
					if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
						if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
							let secondGroupArr = SECOND_GROUP_CODE.split(',')
							SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
						} else {
							SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
						}
					}
					const { operaterInfo } = this.state
					let params = {
						Type: "GetCustomData",
						PageSize: this.state.PageSize,
						PageNo: this.state.PageNo,
						EXAM_CLASS: this.state.showKey,
						NAME: values.NAME,
						SEX: values.SEX,
						ITEM_CODE: values.ITEM_CODE?.split('&')[0] || '',
						APPLY_HOSPITAL_CODE: values.APPLY_HOSPITAL_CODE || '',
						REQ_DEPT_CODE: values.REQ_DEPT_CODE?.split('&')[0] || '',
						EXAM_STATUS: values.EXAM_STATUS.toString(),
						CONSULTATION_STATUS: values.CONSULTATION_STATUS.toString(),
						APPLY_DATETIME: this.state.applyDateTimeChecked
							? [
								moment(values.applyStartTime).format("YYYY-MM-DD"),
								moment(values.applyEndTime).format("YYYY-MM-DD"),
							]
							: "",
						CONSULTATION_DATE: this.state.consultationDateTimeChecked
							? [
								moment(values.consultationStartTime).format("YYYY-MM-DD"),
								moment(values.consultationEndTime).format("YYYY-MM-DD"),
							]
							: "",
						CONSULTATION_DOCTOR_CODE: values.CONSULTATION_DOCTOR_CODE?.split('&')[0] || '',
						CONSULTATION_HOSPITAL_CODE: values.CONSULTATION_HOSPITAL_CODE || '',
						BILLING_DOCTOR: values.BILLING_DOCTOR?.split('&')[0] || '', //开单医生
						FIRST_GROUP_CODE, //一级分组
						SECOND_GROUP_CODE, //二级分组
						OPERATION_UID: values.OPERATION_UID,
						LOGIN_UID: operaterInfo.OPERATION_UID,
					};
					resolve(params);
				}
			});
		});
	};
	//导出
	exportDataList = async () => {
		let params;
		if (this.state.consultationOrLocalSearch === 0) {
			params = await this.beforeInterface();
			params.Type = "ExportCustomData";
		} else {
			params = await this.localBeforeInterface();
			params.Type = "ExportCustomLocal";
		}
		delete params.PageSize;
		delete params.PageNo;
		//检查类型全部导出，不用区分动态心电，静息心电，动态血压
		delete params.EXAM_CLASS;
		getExportCustomData(params).then((res) => {
			this.setState({ tabsloading: false });
			if (res && res.Status === 1) {
				window.location.href = window.g.baseURL + "\\" + res.Result;
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-导出数据报错', 0, true)
			}
		});
	};
	filterOption(input, option) {
		return (
			option.componentOptions.children[0].text
				.toLowerCase()
				.indexOf(input.toLowerCase()) >= 0
		);
	}
	//本地数据与会诊数据切换
	transferToLocalOrConsultationQuery = () => {
		//切换的时候获取操作员
		this.getOperationDoctorList();
		this.setState(
			{
				consultationOrLocalSearch:
					this.state.consultationOrLocalSearch === 0 ? 1 : 0,
			},
			() => {
				this.searchListFn();
			}
		);
	};
	//本地数据获取、更新表头设置
	getCommonColumnInfo = (newTabData) => {
		//获取、更新表头设置
		if (this.state.consultationOrLocalSearch === 0) {
			let commonColumn;
			newTabData =
				newTabData ||
				JSON.parse(localStorage.getItem("operateorCustomSearchCommonColumnSetting")) ||
				this.state.Column;
			commonColumn = getCommonColumnInfoFn(
				this.state.Column,
				newTabData,
				"operateorCustomSearchCommonColumnSetting"
			);
			this.setState({
				commonColumn,
			});
		} else {
			let commonLocalColumn;
			newTabData =
				newTabData ||
				JSON.parse(
					localStorage.getItem("operateorCustomSearchCommonColumnLocalSetting")
				) ||
				this.state.localColumn;
			commonLocalColumn = getCommonColumnInfoFn(
				this.state.localColumn,
				newTabData,
				"operateorCustomSearchCommonColumnLocalSetting"
			);
			this.setState({
				commonLocalColumn,
			});
		}
	};
	//本地数据初始化表头
	initCommonColumn = () => {
		let newTabData =
			JSON.parse(localStorage.getItem("operateorCustomSearchCommonColumnSetting")) ||
			this.state.Column;
		let commonColumn = getCommonColumnInfoFn(
			this.state.Column,
			newTabData,
			"operateorCustomSearchCommonColumnSetting"
		);

		let newLocalTabData =
			JSON.parse(
				localStorage.getItem("operateorCustomSearchCommonColumnLocalSetting")
			) || this.state.localColumn;
		let commonLocalColumn = getCommonColumnInfoFn(
			this.state.localColumn,
			newLocalTabData,
			"operateorCustomSearchCommonColumnLocalSetting"
		);
		this.setState({
			commonColumn,
			commonLocalColumn,
		});
	};
	//双击表头出现设置框
	handleHeader = () => {
		this.setState({
			showColumn: true,
		});
	};
	//本地数获取操作员列表
	getOperationDoctorList = (applyHosptalCode) => {
		const { setFieldsValue } = this.props.form;
		let code =
			typeof applyHosptalCode === "undefined"
				? ''
				: applyHosptalCode;
		let Param = {
			Type: "DoctorData",
			HOSPITAL_CODE: code, //所属医院
		};
		getOperationDoctorList(Param).then((res) => {
			if (res && res.Status === 1) {
				this.setState(
					{
						localReportDoctorList: res.Result.REPORT_DATA,
						localprocessDoctorList: res.Result.CHECK_DATA,
						localBillingDoctorList: res.Result.BILLING_DATA,
						REPORT_DOCTOR_NAME: "",
						REPORT_DOCTOR_UID: "",

						CHECK_DOCTOR_NAME: "",
						CHECK_DOCTOR_CODE: "",
					},
					() => {
						setFieldsValue({
							REPORT_DOCTOR_UID: "",
							CHECK_DOCTOR_CODE: "",
						});
					}
				);
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-本地数获取操作员列表报错', 0, true)
			}
		});
	};
	//本地查询医院名称切换时更新开单医生、报告医生、审核医生的列表
	localApplyHospitalChange = (code) => {
		this.getOperationDoctorList(code);
	};
	//本地查询form数据
	localBeforeInterface = () => {
		this.setState({ tabsloading: true });
		const { operaterInfo } = this.state
		return new Promise((resolve, reject) => {
			this.props.form.validateFields((err, values) => {
				if (!err) {
					if (
						this.state.DateCheckChecked &&
						values.EXAMStartTime > values.EXAMEndTime
					) {
						message.error("检查时间开始时间不得大于结束时间");
						this.setState({ tabsloading: false });
						return;
					}
					if (
						this.state.REPORTSChecked &&
						values.REPORTStartTime > values.REPORTEndTime
					) {
						message.error("报告时间开始时间不得大于结束时间");
						this.setState({ tabsloading: false });
						return;
					}
					if (
						this.state.CHECKSChecked &&
						values.CHECKStartTime > values.CHECKEndTime
					) {
						message.error("审核时间开始时间不得大于结束时间");
						this.setState({ tabsloading: false });
						return;
					}
					let HOSPITAL_CODE = values.HOSPITAL_CODE === ''
						? this.state.operaterInfo.hospitalData.map(item => item.HOSPITAL_CODE).toString()
						: values.HOSPITAL_CODE;
					let params = {
						Type: "GetCustomDataLocal",
						PageSize: this.state.PageSize,
						PageNo: this.state.PageNo,
						EXAM_CLASS: this.state.showKey,
						NAME: values.NAME,
						SEX: values.SEX,
						ITEM_CODE: values.ITEM_CODE?.split('&')[0] || '',
						HOSPITAL_CODE,
						BILLING_DOCTOR: values.BILLING_DOCTOR, //开单医生
						REPORT_DOCTOR_UID: this.state.REPORT_DOCTOR_UID
							? this.state.REPORT_DOCTOR_UID
							: "",
						CHECK_DOCTOR_CODE: this.state.CHECK_DOCTOR_CODE
							? this.state.CHECK_DOCTOR_CODE
							: "",
						REPORT_DOCTOR_NAME: this.state.REPORT_DOCTOR_NAME
							? this.state.REPORT_DOCTOR_NAME
							: "",
						CHECK_DOCTOR_NAME: this.state.CHECK_DOCTOR_NAME
							? this.state.CHECK_DOCTOR_NAME
							: "",
						CONCLUSIONS: values.CONCLUSIONS,
						EXAM_STATUS: values.EXAM_STATUS.toString(),
						EXAM_DATETIME: this.state.DateCheckChecked
							? [
								moment(values.EXAMStartTime).format("YYYY-MM-DD"),
								moment(values.EXAMEndTime).format("YYYY-MM-DD"),
							]
							: "", //检查时间
						REPORT_DATETIME: this.state.REPORTSChecked
							? [
								moment(values.REPORTStartTime).format("YYYY-MM-DD"),
								moment(values.REPORTEndTime).format("YYYY-MM-DD"),
							]
							: "", //报告时间
						CHECK_DATETIME: this.state.CHECKSChecked
							? [
								moment(values.CHECKStartTime).format("YYYY-MM-DD"),
								moment(values.CHECKEndTime).format("YYYY-MM-DD"),
							]
							: "", //审核时间
						OPERATION_UID: '',
						LOGIN_UID: operaterInfo.OPERATION_UID,
					};
					resolve(params);
				}
			});
		});
	};
	//本地查询检查时间
	DateCheckChange = (e) => {
		this.setState({
			DateCheckChecked: e.target.checked,
		});
	};
	//本地查询报告时间
	REPORTSChange = (e) => {
		this.setState({
			REPORTSChecked: e.target.checked,
		});
	};
	//本地查询审核时间
	CHECKSChange = (e) => {
		this.setState({
			CHECKSChecked: e.target.checked,
		});
	};
	saveDoctorName = (type, obj) => {
		if (type === "REPORT_DOCTOR_NAME") {
			this.setState({
				REPORT_DOCTOR_NAME: obj ? obj.split("&")[1] : "",
				REPORT_DOCTOR_UID: obj ? obj.split("&")[0] : "",
			});
		} else if (type === "CHECK_DOCTOR_NAME") {
			this.setState({
				CHECK_DOCTOR_NAME: obj ? obj.split("&")[1] : "",
				CHECK_DOCTOR_CODE: obj ? obj.split("&")[0] : "",
			});
		}
	};
	// 双击查看报告
	handleDoubleClicks = (record) => {
		printPic(record.EXAM_UID).then((res) => {
			if (res && res.Status === 1) {
				const picUrl = window.g.baseURL + "/" + res.Result;
				window.open(picUrl); // 打开pdf文件
			} else {
				requestErrorLog('', '运营综合查询-自定义查询-双击查看报告报错', 0, true)
				this.state.consultationOrLocalSearch === 1 &&
					this.state.showKey === "Holter"
					? message.error("动态心电数据未会诊，无法查看")
					: message.error("数据未完成审核，无法查看");
			}
		});
	};
	//多级联动部分重复代码整合
	someLevelLinkage = (changeIndexName) => {
		//多级联动下拉列表数据变量的名字，需要按联动顺序写（同级别的用,隔开，类似'doctorList,applyHospitalList'）
		let selectListArr = ['firstGroupList', 'secondGroupList', 'consultHospitalList', 'doctorList,applyHospitalList', 'billDoctorList,reqDeptList']
		//多级联动下拉列表form命名的名字，需要按联动按顺序写
		let formItemArr = ['FIRST_GROUP_CODE', 'SECOND_GROUP_CODE', 'CONSULTATION_HOSPITAL_CODE', 'CONSULTATION_DOCTOR_CODE,APPLY_HOSPITAL_CODE', 'BILLING_DOCTOR,REQ_DEPT_CODE']
		//当前触动的下拉列表的位置
		let index = selectListArr.indexOf(changeIndexName)
		//取需要重置列表的数组
		let newSelectListArr = selectListArr.slice(index)
		//取需要重置form的数组
		let newFormItemArr = formItemArr.slice(index)
		let object = {}
		let formObject = {}
		for (let i = 0; i < newSelectListArr.length; i++) {
			let currentSelectListArr = newSelectListArr[i].split(',')//同级别列表需要处理
			if (currentSelectListArr.length > 1) {
				for (let k = 0; k < currentSelectListArr.length; k++) {
					object[currentSelectListArr[k]] = []
				}
			} else {
				object[newSelectListArr[i]] = []
			}
			let currentFormItem = newFormItemArr[i]
			if (currentFormItem === 'SECOND_GROUP_CODE') {//二级分组下拉列表框是一个初始化是个对象
				formObject[currentFormItem] = []
				// this.props.form.setFieldsValue({ [currentFormItem]: [] })
			}
			else if (currentFormItem === 'CONSULTATION_HOSPITAL_CODE') {//非监管机构和平台管理账号会诊医院默认值不做修改
				formObject[currentFormItem] = ''
				this.setState({ CONSULTATION_HOSPITAL_CODE: "", });
			}
			else {
				let currentFormItemArr = currentFormItem.split(',')//同级别列表需要处理
				if (currentFormItemArr.length > 1) {
					for (let j = 0; j < currentFormItemArr.length; j++) {
						currentFormItem = currentFormItemArr[j]
						formObject[currentFormItem] = ''
					}

				} else {
					formObject[currentFormItem] = ''
				}
			}

		}
		this.props.form.setFieldsValue(formObject)
		return object
	}
	handleFirstChange = (e) => {
		let FIRST_GROUP_CODE = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			FIRST_GROUP_CODE = this.state.firstGroupList ? this.state.firstGroupList?.map((item) => item.FIRST_GROUP_CODE) : []
			this.props.form.setFieldsValue({
				FIRST_GROUP_CODE,

			})
		} else {
			this.props.form.setFieldsValue({
				FIRST_GROUP_CODE: [],
			})
		}
		this.firstGroupChange(FIRST_GROUP_CODE)
	}
	handleSecondChange = (e) => {
		let SECOND_GROUP_CODE = []
		if (e.target.checked) {//取做所有一级分组值赋给一级分组
			SECOND_GROUP_CODE = this.state.secondGroupList ? this.state.secondGroupList?.map((item) => item.SECOND_GROUP_CODE) : []
			this.props.form.setFieldsValue({
				SECOND_GROUP_CODE,
			})
		} else {
			this.props.form.setFieldsValue({
				SECOND_GROUP_CODE: [],
			})
		}
		this.secondGroupChange(SECOND_GROUP_CODE)
	}
	render() {
		const { getFieldDecorator } = this.props.form;
		const {
			defaultSelectDate: { startDate, endDate },
			tabsloading,
			billDoctorList,
			consultationOrLocalSearch,
			showColumn,
			commonColumn,
			commonLocalColumn,
			localReportDoctorList,
			localprocessDoctorList,
			localBillingDoctorList,
			applyHosptalList,
			firstGroupList,
			secondGroupList,
			firstGroupName,
			secondGroupName,
		} = this.state;
		let firstGroupLength = '+' + firstGroupName?.length;
		let secondGroupLength = '+' + secondGroupName?.length;
		return (
			<>
				<div style={{ flex: 1 }}>
					<Spin spinning={tabsloading} tip="Loading...">
						{consultationOrLocalSearch === 0 ? (
							<Form
								layout="inline"
								className="commonCase customSearchBox">
								<div>
									<FormItem label="患者姓名">
										{getFieldDecorator("NAME", { initialValue: "" })(<Input />)}
									</FormItem>
									<FormItem label="性别">
										{getFieldDecorator("SEX", { initialValue: "" })(
											<Select>
												<Option value="">全部</Option>
												<Option value="M">男</Option>
												<Option value="F">女</Option>
												<Option value="U">未知</Option>
												<Option value="W">未说明</Option>
											</Select>
										)}
									</FormItem>
									<Form.Item label="一级分组" style={{ width: "265px" }}>
										<Tooltip overlayClassName='tooltipColor distance' title={firstGroupName.toString()}>
											{getFieldDecorator(
												"FIRST_GROUP_CODE",
												{}
											)(
												<Select
													className='noWrapSelect'
													maxTagCount={1}
													maxTagPlaceholder={firstGroupLength}
													maxTagTextLength={8}
													allowClear
													showSearch
													optionFilterProp="children"
													mode="multiple"
													style={{ width: "200px", top: '4px' }}
													onChange={this.firstGroupChange}
													dropdownRender={(allSelectValue) => (
														<div>
															<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
																<Checkbox
																	checked={this.state.selectFirstAllState}
																	onChange={this.handleFirstChange}
																	indeterminate={this.state.indeterminateFirst}
																>
																</Checkbox>
																&nbsp;&nbsp;全选
															</div>
															<Divider style={{ margin: "0" }} />
															{allSelectValue}
														</div>
													)}
												>
													{firstGroupList.map((item, index) => (
														<Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
															{item.FIRST_GROUP_NAME}
														</Option>
													))}
												</Select>
											)}
										</Tooltip>
									</Form.Item>

									<Form.Item label="二级分组" style={{ width: "265px" }}>
										<Tooltip overlayClassName='tooltipColor distance' title={secondGroupName.toString()}>
											{getFieldDecorator(
												"SECOND_GROUP_CODE",
												{}
											)(
												<Select
													className='noWrapSelect'
													maxTagCount={1}
													maxTagPlaceholder={secondGroupLength}
													maxTagTextLength={8}
													mode="multiple"
													allowClear
													showSearch
													optionFilterProp="children"
													style={{ width: "200px", top: '4px' }}
													onChange={this.secondGroupChange}
													dropdownRender={(allSelectValue) => (
														<div>
															<div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
																<Checkbox
																	checked={this.state.selectSecondAllState}
																	onChange={this.handleSecondChange}
																	indeterminate={this.state.indeterminateSecond}
																>
																</Checkbox>
																&nbsp;&nbsp;全选
															</div>
															<Divider style={{ margin: "0" }} />
															{allSelectValue}
														</div>
													)}
												>
													{secondGroupList.map((item, index) => (
														<Option key={index + item.SECOND_GROUP_CODE} value={item.SECOND_GROUP_CODE}>
															{item.SECOND_GROUP_NAME}
														</Option>
													))}
												</Select>
											)}
										</Tooltip>
									</Form.Item>
									<FormItem label="会诊医院">
										{getFieldDecorator("CONSULTATION_HOSPITAL_CODE", {
											initialValue: "",
										})(
											<Select
												onChange={this.consultHospitalChange}
												showSearch
												optionFilterProp="children">
												<Option value="">全部</Option>
												{this.state.consultHospitalList
													? this.state.consultHospitalList.map((item) => (
														<Option
															key={item.HOSPITAL_CODE}
															value={item.HOSPITAL_CODE}>
															{item.HOSPITAL_NAME}
														</Option>
													))
													: null}
											</Select>
										)}
									</FormItem>
									<FormItem label="会诊人">
										{getFieldDecorator("CONSULTATION_DOCTOR_CODE", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{this.state.doctorList.map((item, index) => (
													<Option key={item.USER_UID + '&' + index} value={item.USER_UID + '&' + index}>
														{item.REAL_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
								</div>
								<div>
									<FormItem label="申请医院">
										{getFieldDecorator("APPLY_HOSPITAL_CODE", {
											initialValue: "",
										})(
											<Select
												onChange={this.applyHospitalChange}
												showSearch
												optionFilterProp="children">
												<Option value="">全部</Option>
												{this.state.applyHospitalList.map((item) => (
													<Option
														key={item.APPLY_HOSPITAL_CODE}
														value={item.APPLY_HOSPITAL_CODE}>
														{item.APPLY_HOSPITAL_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="开单医生">
										{getFieldDecorator("BILLING_DOCTOR", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{billDoctorList.map((item, index) => (
													<Option key={index} value={item.BILLING_DOCTOR + '&' + index}>
														{item.BILLING_DOCTOR}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="申请科室">
										{getFieldDecorator("REQ_DEPT_CODE", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{this.state.reqDeptList.map((item, index) => (
													<Option key={item.DEPT_CODE + '&' + index} value={item.DEPT_CODE + '&' + index}>
														{item.DEPT_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="业务人员">
										{getFieldDecorator("OPERATION_UID", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{this.state.salesmanData.map((item, index) => (
													<Option key={item.OPERATION_UID} value={item.OPERATION_UID}>
														{item.OPERATION_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="检查项目">
										{getFieldDecorator("ITEM_CODE", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{this.state.examGroupItemList.map((item, index) => (
													<Option key={item.ITEM_CODE + '&' + index} value={item.ITEM_CODE + '&' + index}>
														{item.ITEM_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="报告状态">
										{getFieldDecorator("EXAM_STATUS", { initialValue: [] })(
											<CheckboxGroup
												options={this.state.examStatusList}></CheckboxGroup>
										)}
									</FormItem>
								</div>
								<div style={{ display: "flex" }}>
									<FormItem label="会诊状态">
										{getFieldDecorator("CONSULTATION_STATUS", {
											initialValue: [],
										})(
											<CheckboxGroup
												options={
													this.state.consultationStatusList
												}></CheckboxGroup>
										)}
									</FormItem>
									<div className="DateCheckBox">
										<Checkbox
											style={{ marginRight: "-20px" }}
											checked={this.state.applyDateTimeChecked}
											onChange={this.applyDateTimeChange}></Checkbox>
										<FormItem label="申请会诊日期" className="mark dateTime">
											{getFieldDecorator("applyStartTime", {
												initialValue: startDate,
											})(
												<DatePicker
													style={{ width: 125 }}
													allowClear={false}
													placeholder="开始日期"
													disabledDate={this.disabledDate}
												/>
											)}
											<span
												style={{
													display: "inline-block",
													textAlign: "center",
													width: 15,
												}}>
												-
											</span>
											<FormItem style={{ width: 110 }}>
												{getFieldDecorator("applyEndTime", {
													initialValue: endDate,
												})(
													<DatePicker
														style={{ width: 125 }}
														allowClear={false}
														placeholder="结束日期"
														disabledDate={this.disabledDate}
													/>
												)}
											</FormItem>
										</FormItem>
										<Checkbox
											style={{ marginRight: "-20px" }}
											checked={this.state.consultationDateTimeChecked}
											onChange={this.consultationDateTimeChange}></Checkbox>
										<FormItem label="完成会诊日期" className="mark dateTime">
											{getFieldDecorator("consultationStartTime", {
												initialValue: startDate,
											})(
												<DatePicker
													style={{ width: 125 }}
													allowClear={false}
													placeholder="开始日期"
													disabledDate={this.disabledDate}
												/>
											)}
											<span
												style={{
													display: "inline-block",
													textAlign: "center",
													width: 15,
												}}>
												-
											</span>
											<FormItem style={{ width: 110 }}>
												{getFieldDecorator("consultationEndTime", {
													initialValue: endDate,
												})(
													<DatePicker
														style={{ width: 125 }}
														allowClear={false}
														placeholder="结束日期"
														disabledDate={this.disabledDate}
													/>
												)}
											</FormItem>
										</FormItem>
									</div>
									<FormItem className="btn">
										<Button
											style={{ marginRight: "10px" }}
											onClick={this.searchListFn}>
											查 询
										</Button>
										<Button onClick={() => this.handleChangeReset()}>
											重 置
										</Button>
									</FormItem>
									<FormItem className="btn">
										<Button onClick={() => this.exportDataList()}>导 出</Button>
									</FormItem>
								</div>
							</Form>
						) : (
							<Form
								layout="inline"
								className="commonCase customSearchBox"
								style={{ height: "145px" }}>
								<div>
									<FormItem label="患者姓名">
										{getFieldDecorator("NAME", { initialValue: "" })(<Input />)}
									</FormItem>
									<FormItem label="性别">
										{getFieldDecorator("SEX", { initialValue: "" })(
											<Select>
												<Option value="">全部</Option>
												<Option value="M">男</Option>
												<Option value="F">女</Option>
												<Option value="U">未知</Option>
												<Option value="W">未说明</Option>
											</Select>
										)}
									</FormItem>
									<FormItem label="医院名称">
										{getFieldDecorator("HOSPITAL_CODE", {
											initialValue: '',
										})(
											<Select
												onChange={this.localApplyHospitalChange}
												showSearch
												optionFilterProp="children">
												<Option value="">全部</Option>
												{applyHosptalList
													? applyHosptalList.map((item) => (
														<Option
															key={item.HOSPITAL_CODE}
															value={item.HOSPITAL_CODE}>
															{item.HOSPITAL_NAME}
														</Option>
													))
													: null}
											</Select>
										)}
									</FormItem>

									<FormItem label="开单医生">
										{getFieldDecorator("BILLING_DOCTOR", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{localBillingDoctorList.map((item, index) => (
													<Option key={index} value={item.BILLING_DOCTOR}>
														{item.BILLING_DOCTOR}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
								</div>
								<div>
									<FormItem label="报告医生">
										{getFieldDecorator("REPORT_DOCTOR_UID", {
											initialValue: "",
										})(
											<Select
												onChange={this.saveDoctorName.bind(
													this,
													"REPORT_DOCTOR_NAME"
												)}
												showSearch
												optionFilterProp="children">
												<Option value="">全部</Option>
												{localReportDoctorList.map((item, index) => {
													return (
														<Option
															key={index}
															value={
																item.REPORT_DOCTOR_UID +
																"&" +
																item.REPORT_DOCTOR_NAME +
																"&" +
																index
															}>
															{item.REPORT_DOCTOR_NAME}
														</Option>
													);
												})}
											</Select>
										)}
									</FormItem>
									<FormItem label="审核医生">
										{getFieldDecorator("CHECK_DOCTOR_CODE", {
											initialValue: "",
										})(
											<Select
												onChange={this.saveDoctorName.bind(
													this,
													"CHECK_DOCTOR_NAME"
												)}
												showSearch>
												<Option value="">全部</Option>
												{localprocessDoctorList.map((item, index) => (
													<Option
														key={index}
														value={
															item.CHECK_DOCTOR_CODE +
															"&" +
															item.CHECK_DOCTOR_NAME +
															"&" +
															index
														}>
														{item.CHECK_DOCTOR_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="检查结论">
										{getFieldDecorator("CONCLUSIONS", { initialValue: "" })(
											<Input />
										)}
									</FormItem>
									<FormItem label="检查项目">
										{getFieldDecorator("ITEM_CODE", {
											initialValue: "",
										})(
											<Select>
												<Option value="">全部</Option>
												{this.state.examGroupItemList.map((item, index) => (
													<Option key={item.ITEM_CODE + '&' + index} value={item.ITEM_CODE + '&' + index}>
														{item.ITEM_NAME}
													</Option>
												))}
											</Select>
										)}
									</FormItem>
									<FormItem label="报告状态">
										{getFieldDecorator("EXAM_STATUS", { initialValue: [] })(
											<CheckboxGroup
												options={this.state.examStatusList}></CheckboxGroup>
										)}
									</FormItem>
								</div>
								<div style={{ display: "flex" }}>
									<div className="DateCheckBox" style={{ paddingLeft: "0px" }}>
										<Checkbox
											style={{ marginRight: "-45px" }}
											checked={this.state.DateCheckChecked}
											onChange={this.DateCheckChange}></Checkbox>
										<FormItem label="检查时间" className="mark dateTime">
											{getFieldDecorator("EXAMStartTime", {
												initialValue: startDate,
											})(
												<DatePicker
													style={{ width: 125 }}
													allowClear={false}
													placeholder="开始日期"
													disabledDate={this.disabledDate}
												/>
											)}
											<span
												style={{
													display: "inline-block",
													textAlign: "center",
													width: 15,
												}}>
												-
											</span>
											<FormItem style={{ width: 110 }}>
												{getFieldDecorator("EXAMEndTime", {
													initialValue: endDate,
												})(
													<DatePicker
														style={{ width: 125 }}
														allowClear={false}
														placeholder="结束日期"
														disabledDate={this.disabledDate}
													/>
												)}
											</FormItem>
										</FormItem>
										<Checkbox
											style={{ marginRight: "-45px" }}
											checked={this.state.REPORTSChecked}
											onChange={this.REPORTSChange}></Checkbox>
										<FormItem label="报告时间" className="mark dateTime">
											{getFieldDecorator("REPORTStartTime", {
												initialValue: startDate,
											})(
												<DatePicker
													style={{ width: 125 }}
													allowClear={false}
													placeholder="开始日期"
													disabledDate={this.disabledDate}
												/>
											)}
											<span
												style={{
													display: "inline-block",
													textAlign: "center",
													width: 15,
												}}>
												-
											</span>
											<FormItem style={{ width: 110 }}>
												{getFieldDecorator("REPORTEndTime", {
													initialValue: endDate,
												})(
													<DatePicker
														style={{ width: 125 }}
														allowClear={false}
														placeholder="结束日期"
														disabledDate={this.disabledDate}
													/>
												)}
											</FormItem>
										</FormItem>
										<Checkbox
											style={{ marginRight: "-45px" }}
											checked={this.state.CHECKSChecked}
											onChange={this.CHECKSChange}></Checkbox>
										<FormItem label="审核时间" className="mark dateTime">
											{getFieldDecorator("CHECKStartTime", {
												initialValue: startDate,
											})(
												<DatePicker
													style={{ width: 125 }}
													allowClear={false}
													placeholder="开始日期"
													disabledDate={this.disabledDate}
												/>
											)}
											<span
												style={{
													display: "inline-block",
													textAlign: "center",
													width: 15,
												}}>
												-
											</span>
											<FormItem style={{ width: 110 }}>
												{getFieldDecorator("CHECKEndTime", {
													initialValue: endDate,
												})(
													<DatePicker
														style={{ width: 125 }}
														allowClear={false}
														placeholder="结束日期"
														disabledDate={this.disabledDate}
													/>
												)}
											</FormItem>
										</FormItem>
									</div>
									<FormItem className="btn">
										<Button
											style={{ marginRight: "10px" }}
											onClick={this.searchListFn}>
											查 询
										</Button>
										<Button onClick={() => this.handleChangeResetLocal()}>
											重 置
										</Button>
									</FormItem>
									<FormItem className="btn">
										<Button onClick={() => this.exportDataList()}>导 出</Button>
									</FormItem>
								</div>
							</Form>
						)}
						<div className="eleWrap applyTd" style={{ maxWidth: "1740px" }}>
							<Tabs
								defaultActiveKey={this.state.showKey}
								type="card"
								onChange={this.handleTabKey}
								tabBarExtraContent={
									<Button onClick={this.transferToLocalOrConsultationQuery}>
										{consultationOrLocalSearch === 0
											? "转入本地查询"
											: "转入会诊查询"}
									</Button>
								}>
								<TabPane key="ECG" tab={<p className="badgeText">静息心电</p>}>
									<Table
										columns={
											consultationOrLocalSearch === 0
												? commonColumn
												: commonLocalColumn
										}
										dataSource={this.state.dataList}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage,
											showTotal: (total) => `共 ${total} 条`,
										}}
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column),
											};
										}}
										onRow={(record) => {
											return {
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												}, //双击行
											};
										}}
									/>
								</TabPane>
								<TabPane
									key="Holter"
									tab={<p className="badgeText">动态心电</p>}>
									<Table
										columns={
											consultationOrLocalSearch === 0
												? commonColumn
												: commonLocalColumn
										}
										dataSource={this.state.dataList}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage,
											showTotal: (total) => `共 ${total} 条`,
										}}
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column),
											};
										}}
										onRow={(record) => {
											return {
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												}, //双击行
											};
										}}
									/>
								</TabPane>
								<TabPane
									key="BloodPressure"
									tab={<p className="badgeText">动态血压</p>}>
									<Table
										columns={
											consultationOrLocalSearch === 0
												? commonColumn
												: commonLocalColumn
										}
										dataSource={this.state.dataList}
										rowKey={(record) => record.EXAM_UID} // 需要修改为唯一的ID！
										scroll={{ x: 380, scrollToFirstRowOnChange: true }}
										pagination={{
											total: this.state.RowCount,
											current: this.state.PageNo,
											onChange: this.onChangePage,
											showTotal: (total) => `共 ${total} 条`,
										}}
										onHeaderRow={(column) => {
											return {
												onDoubleClick: (e) => this.handleHeader(column),
											};
										}}
										onRow={(record) => {
											return {
												onDoubleClick: (e) => {
													this.handleDoubleClicks(record);
												}, //双击行
											};
										}}
									/>
								</TabPane>
							</Tabs>
						</div>
					</Spin>
				</div>
				{showColumn ? (
					<EditTable
						visible={showColumn}
						setTabData={
							consultationOrLocalSearch === 0
								? JSON.parse(
									localStorage.getItem("customSearchCommonColumnSetting")
								) || this.state.Column
								: JSON.parse(
									localStorage.getItem("customSearchCommonColumnLocalSetting")
								) || this.state.localColumn
						}
						updateParent={this.getCommonColumnInfo}
						onRef={(ref) => {
							this.setState({ showColumn: ref.showColumn });
						}}
					/>
				) : null}
			</>
		);
	}
}

export default Form.create()(CustomSearch);
